export default __webpack_public_path__ + "97d8e413642c33a58b7dc36956fa9ae1.png";